/**
 * Highrise.js
 *
 * @class   Highrise
 * @author  Dan Goldshlack
 *
 */

import React from 'react';
import D3 from 'd3';

export default React.createClass({

	displayName: 'Highrise',

	propTypes: {

	},

	render() {

		return <h3>Highrise</h3>

	}

});



/** WEBPACK FOOTER **
 ** ./src/charts/highrise/Highrise.js
 **/